import { useState, useEffect } from "react";
import { API_BASE_URL } from "../../../config/api";
import { SPLITS_KINDS } from "../../splits-report-page/components/splits-field-config";
import { SplitsReportPrintTable } from "../../splits-report-page/components/splits-report-print-table";

const WIDTH = 1056;
const HEIGHT = 816;

export const SplitsReportRender = () => {
  const [ready, setReady] = useState(false);
  const config =
    window.__SPLITS_REPORT_CONFIG__ ||
    JSON.parse(sessionStorage.getItem("splitsReportConfig") || "{}") ||
    {};
  const { kind = "batter", rows = [], report = {} } = config;
  const meta = SPLITS_KINDS[kind] || SPLITS_KINDS.batter;

  useEffect(() => {
    setReady(true);
  }, []);

  return (
    <div className="bg-white" data-export-ready={ready ? "true" : undefined}>
      <div
        className="relative bg-white overflow-hidden"
        style={{ width: WIDTH, minHeight: HEIGHT }}
      >
        <div className="bg-gradient-to-r from-blue-800 to-blue-600 px-8 py-5 flex items-center justify-between">
          <div className="flex items-center gap-5">
            {report.teamId && (
              <div className="w-14 h-14 rounded-xl overflow-hidden bg-white/10 ring-2 ring-white/20 flex-shrink-0">
                <img
                  src={`${API_BASE_URL}/api/team-logo/${report.teamId}`}
                  alt={report.teamName}
                  className="w-full h-full object-contain p-1"
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                  }}
                />
              </div>
            )}
            <div>
              <div className="text-2xl font-bold text-white">{report.teamName}</div>
              <div className="text-blue-200 text-sm mt-0.5">
                {meta.reportType} · {report.year}
              </div>
            </div>
          </div>
        </div>

        <div className="px-8 pt-5 pb-10">
          <SplitsReportPrintTable rows={rows} kind={kind} />
        </div>

        <div className="absolute bottom-4 left-0 right-0 text-center">
          <span className="text-gray-300 text-[9px]">
            Generated by D3 Dashboard · {new Date().toLocaleDateString()}
          </span>
        </div>
      </div>
    </div>
  );
};
